import InfantilMariposas from "./InfantilMariposas";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "infantil-mariposas",
  tipoEvento: "infantil",
  tipoEtiqueta: "Cumpleaños infantil",
  nombre: "Jardín de Mariposas",
  descripcion:
    "Diseño dulce de jardín para nenas: nombre manuscrito protagonista, mariposas que aletean, flores originales y la edad dentro de una flor. Sin personajes comerciales.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    primavera: "/miniaturas/infantil-mariposas-primavera.jpg",
    lavandaDulce: "/miniaturas/infantil-mariposas-lavandaDulce.jpg",
    melon: "/miniaturas/infantil-mariposas-melon.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: InfantilMariposas,
};
